import { useLocalObservable } from "mobx-react-lite";
import { useCallback } from "react";

import { MessageStore } from "@/components/Playground/Messages/Message/message-store";
import { MessageType } from "@/components/Playground/types";
import { Content } from "@/types";

export interface ChatMessagePayload {
  role: MessageType;
  content: Content[];
}

export const useChatMessageInput = () => {
  const messageStore = useLocalObservable(
    () =>
      new MessageStore({
        id: "chat-input",
        role: "user",
        content: [{ type: "text", text: "" }],
      }),
  );

  const resetInput = useCallback(() => {
    messageStore.replace({
      id: "chat-input",
      role: "user",
      content: [{ type: "text", text: "" }],
    });
  }, [messageStore]);

  const getPayload = useCallback((): ChatMessagePayload => {
    const message = messageStore.toMessage();
    return {
      role: message.role,
      content: message.content,
    };
  }, [messageStore]);

  const isEmpty = messageStore.content.trim() === "" && messageStore.mediaContent.length === 0;

  return {
    messageStore,
    resetInput,
    getPayload,
    isEmpty,
  };
};
